import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import stringHelper from '../../../../Helpers/stringHelper';
import UserService from '../../../../Services/userService';
import ErrorMessage from '../../../ErrorMessage';
import OfficeService from '../../../../Services/OfficeService';

export default class ProjectManagerSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    editedItem: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    UserService.GetUserList()
      .then((result) => {
        result.sort((a, b) =>
          `${a.lastname} ${a.firstName}`.toLocaleLowerCase() > `${b.lastname} ${b.firstName}`.toLocaleLowerCase()
            ? 1
            : -1
        );
        OfficeService.GetOfficesForSelect()
          .then((offices) => {
            const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
            result.forEach((user) => {
              optValues.push({
                label: `${user.firstName} ${user.lastName}${stringHelper.toBracket(
                  offices.find((f) => f.officeId === user.officeId)?.name
                )}`,
                value: user.userId,
                disabled: false,
              });
            });
            // M: If the currently selected project manager was disabled, it is not in the list.
            // If that is the case, we have to add it as an extra value here, so the selection is not left empty by default.
            if (!optValues.some((s) => s.value === this.props.value)) {
              optValues.push({
                label: `Currently selected (disabled) - ${this.props.editedItem.CfProjectManagerName}`,
                value: this.props.value,
                disabled: false,
              });
            }

            this.setState({ selectValues: optValues });
          })
          .catch(() => {
            this.setState({ selectValues: [] });
            ErrorMessage.SetErrorMessage('PMS63');
          });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('PMS69');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
